export const useSwiper = () => {
  const swiperPhotoSlider = (selector = ".property_list .photo_list") => new Swiper(selector, {
    loop: true,
    speed: 300,
    spaceBetween: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  })

  const swiperSlider = (selector) => new Swiper(selector, {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    slidesPerGroup: 1,
    slidesPerView: 'auto',
    // autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
       768: {
        spaceBetween: 24,
      },
    }
  })

  return {
    swiperPhotoSlider,
    swiperSlider,
  }
}
